// import React, { useEffect, useContext } from "react";
import "../Styles/Service.css"; // Import the CSS file
import LazyLoad from "react-lazyload";
import { FaTag } from "react-icons/fa";
import { IoBagHandleSharp } from "react-icons/io5";
import { BsPlusSquareDotted } from "react-icons/bs";
import { HiOutlineDocumentText } from "react-icons/hi";
import { MdFastfood } from "react-icons/md";
import center from "../images/center.png";
// import { AppContext } from "../Context/Provider";
import { useMediaQuery } from "react-responsive";
const ServicesConvinience = () => {
  // const { FetchHomeLearnMore, HomeLearnMoreData } = useContext(AppContext);

  // useEffect(() => {
  //   FetchHomeLearnMore();
  // }, []);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const c = isMobile ? { marginTop: "0px" } : { marginTop: "0px" };
  return (
    <section
      className="py-10 learn-about-us-section"
      style={{ paddingRight: "8%", paddingLeft: "8%", ...c }}
    >
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between px-4">
        <div className="w-full sm:w-1/2 flex flex-col justify-center h-full mt-20 sm:mt-0">
          <div className="my-4 flex items-start sm:my-6">
            <div className="w-12 h-10 flex items-center justify-center rounded-lg bg-white mr-3 sm:mr-4">
              <MdFastfood className="w-8 h-8" color="#4CAF4F" size={24} />
            </div>
            <div>
              <h4 className="font-semibold text-xl sm:text-2xl">
                Variety of Cuisines
              </h4>
              <p className="text-gray-700 text-sm sm:text-base">
                Explore a diverse selection of local restaurants and
                international cuisines, all available for delivery.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start sm:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white mr-3 sm:mr-4">
              <HiOutlineDocumentText
                className="w-8 h-8"
                color="#4CAF4F"
                size={24}
              />
            </div>
            <div>
              <h4 className="font-semibold text-xl sm:text-2xl">
                Easy Ordering
              </h4>
              <p className="text-gray-700 text-sm sm:text-base">
                Browse menus, customize your orders, and track your delivery
                with just a few clicks on our app.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start sm:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white mr-3 sm:mr-4">
              <BsPlusSquareDotted className="w-8 h-8" color="#4CAF4F" />
            </div>
            <div>
              <h4 className="font-semibold text-xl sm:text-2xl">
                Wide Selection
              </h4>
              <p className="text-gray-700 text-sm sm:text-base">
                Access a comprehensive range of products, including fresh
                produce, pantry staples, personal care items, and more.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start sm:my-6">
            <div className="w-12 h-10 flex items-center justify-center rounded-lg bg-white mr-3 sm:mr-4">
              <IoBagHandleSharp className="w-8 h-8" color="#4CAF4F" />
            </div>
            <div>
              <h4 className="font-semibold text-xl sm:text-2xl">
                Convenient Shopping
              </h4>
              <p className="text-gray-700 text-sm sm:text-base">
                Our intuitive platform makes it easy to find and purchase
                everything you need from the comfort of your home.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start sm:my-6">
            <div className="w-12 h-10 flex items-center justify-center rounded-lg bg-white mr-3 sm:mr-4">
              <FaTag className="w-8 h-8" color="#4CAF4F" size={24} />
            </div>
            <div>
              <h4 className="font-semibold text-xl sm:text-2xl">
                Competitive Prices
              </h4>
              <p className="text-gray-700 text-sm sm:text-base">
                Enjoy great deals and savings on a wide array of products, with
                options to suit every budget.
              </p>
            </div>
          </div>
        </div>

        <div className="md:w-1/2 flex justify-center items-center">
          {/* {HomeLearnMoreData?.map((img) => {
            return ( */}
          <LazyLoad height={795} offset={100} once key={center}>
            <img
              src={center}
              alt="Rikaab App Screenshot"
              width="511"
              height="795"
            />
          </LazyLoad>
          {/* );
          })} */}
        </div>
      </div>
    </section>
  );
};

export default ServicesConvinience;
